var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Grau_InstrucaoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Grau_InstrucaoModule = class Grau_InstrucaoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Grau_InstrucaoActions.POST_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.post("Grau_Instrucao/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Grau_InstrucaoActions.PUT_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.put("Grau_Instrucao/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Grau_InstrucaoActions.DELETE_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.delete("Grau_Instrucao/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Grau_InstrucaoActions.DELETE_RANGE_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.delete("Grau_Instrucao/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Grau_InstrucaoActions.FILTER_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.post("Grau_Instrucao/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Grau_InstrucaoActions.GET_GRAU_INSTRUCAO]() {
        return new Promise(resolve => {
            fornecService.get("Grau_Instrucao/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Grau_InstrucaoActions.GETWITHDISABLED_GRAU_INSTRUCAO]() {
        return new Promise(resolve => {
            fornecService.get("Grau_Instrucao/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Grau_InstrucaoActions.GET_BY_ID_GRAU_INSTRUCAO](data) {
        return new Promise(resolve => {
            fornecService.get("Grau_Instrucao/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_InstrucaoModule.prototype, _h, null);
Grau_InstrucaoModule = __decorate([
    Module
], Grau_InstrucaoModule);
export default Grau_InstrucaoModule;
//# sourceMappingURL=Grau_InstrucaoModule.js.map